var map = {
	"./Blockchain.svg": 600,
	"./Obras.svg": 601,
	"./Reporte.svg": 602,
	"./Transparency.svg": 603,
	"./Urbanism.svg": 604,
	"./alert-active.svg": 525,
	"./alert-inactive.svg": 526,
	"./alert.svg": 605,
	"./analizar.svg": 521,
	"./atencion.svg": 606,
	"./categoria.svg": 607,
	"./caution-active.svg": 527,
	"./caution.svg": 608,
	"./configuracion.svg": 609,
	"./datos.svg": 610,
	"./defeated-active.svg": 528,
	"./defeated.svg": 611,
	"./delete-active.svg": 529,
	"./delete-inactive.svg": 530,
	"./delete.svg": 612,
	"./estadistica.svg": 613,
	"./expediente.svg": 614,
	"./facebook.svg": 615,
	"./historial.svg": 522,
	"./m-Blockchain.svg": 516,
	"./m-Reporte.svg": 531,
	"./m-Transparency.svg": 532,
	"./m-Urbanism.svg": 533,
	"./mapa.svg": 616,
	"./mexico.svg": 617,
	"./not_priority.svg": 534,
	"./nuevoReporte.svg": 618,
	"./organizacion.svg": 619,
	"./reporte-act.svg": 620,
	"./reporte-in.svg": 621,
	"./tabla.svg": 622,
	"./time-active.svg": 535,
	"./time.svg": 623,
	"./trackers.svg": 624,
	"./twitter.svg": 625,
	"./vacio.svg": 536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;